import { Text } from 'app/design/primitives/text';
import type { TransactionMode } from 'app/types/listing';
import { useTranslation } from 'react-i18next';

interface MyOffersEmptyStateProps {
  transactionMode: TransactionMode | 'all';
}

export function MyOffersEmptyState({ transactionMode }: MyOffersEmptyStateProps) {
  const { t } = useTranslation('my-listings');

  return (
    <Text
      color="text.secondary"
      fontWeight="600"
      marginHorizontal="spacing.general.x4"
      marginTop="spacing.general.x4"
      textAlign="center"
      variant="bodyBase"
    >
      {t(`emptyState.${transactionMode}`)}
    </Text>
  );
}
